import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

type ConfirmationColor = 'primary' | 'warn';

interface ResolveDialogOptions {
  title: string;
  message: string;
  inputLabel?: string;
  confirmationLabel?: string;
  confirmationColor?: ConfirmationColor;
}

@Component({
  selector: 'app-resolve-dialog',
  templateUrl: './resolve-dialog.component.html',
  styleUrls: ['./resolve-dialog.component.scss'],
})
export class ResolveActivationDialogComponent {
  title: string;
  message: string;
  inputLabel: string;
  inputValue: string;
  confirmationLabel: string;
  confirmationColor: ConfirmationColor;

  constructor(
    public dialogRef: MatDialogRef<ResolveActivationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResolveDialogOptions,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.inputLabel = data.inputLabel;
    this.confirmationLabel = data.confirmationLabel;
    this.confirmationColor = data.confirmationColor;
  }

  onOk(): void {
    if (this.inputLabel && !this.inputValue) return; // don't close if input empty
    this.dialogRef.close(this.inputLabel ? this.inputValue : true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
